
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/news-releases",
      function () {
        return require("private-next-pages/media/news-releases/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/news-releases"])
      });
    }
  